import React, { useState } from 'react'
import axios from '../utils/axios'
import site from "../utils/SiteSettings"

//toast
import 'react-toastify/dist/ReactToastify.css'; // import first and after the toastify is work 
import { toast } from 'sonner'
import { Link } from 'react-router-dom';

export const ForgotPassword = () => {
    
    const [email, setEmail] = useState('')
    // eslint-disable-next-line
    const [show, setShow] = useState(false)


    const hadleSubmit = async(e)=>{
        e.preventDefault();
        try {
            await axios.put("forgot/password",{
                email:email,
                command: 'stop'
            },
            {
                headers:{"Content-Type": "application/json"},
                withCredentials:true,
            }
        ).then((res)=>{
                
                setTimeout(()=>{
                    window.location.href="/login"
                },4000)
                setShow(!show)
                console.log("Forgot Password link sended successfully, Check your Email")
                toast.success("Forgot Password link sended successfully, Check your Email",{position:'top-right'})
                
            }).catch((err)=>{
                console.log(err.message)
                // toast.success("",{position:'top-right'})
                toast.error("Email not found",{position:'top-right'})
                
            })
           
        } catch (err) {
            console.log(err.message)
            toast.error(err.message,{position:"bottom-center"})
        }
    }


  return (
    <div>
        {/* <!-- section start --> */}
        <section className="login-section section-b-space">
            <Link to={'/'} className="logo-auth">{site?.site?.siteName}</Link>
            <div className="row m-0">
                <div className="col-lg-7 d-lg-inline-block d-none p-0">
                    <div className="login-animation">
                        <img src={require("../../assets/svg/home/log3.svg").default} data-aos="fade-up" data-aos-duration="1000" data-aos-delay="100"
                            className="img-fluid img-base aos-animate w-600" alt=""/>
                        <img  src={require("../../assets/svg/home/log1.svg").default} data-aos="zoom-in-up" data-aos-duration="1000"
                            data-aos-delay="1000" className="img-fluid img-light aos-animate w-600" alt=""/>
                        <div className="img-face" data-aos-delay="2500" data-aos="flip-left" data-aos-easing="ease-out-cubic"
                            data-aos-duration="1000"> <img  src={require("../../assets/svg/home/log.svg").default} className="img-fluid aos-animate w-450" alt=""/></div>
                    </div>
                </div>
                <div className="col-xxl-4 col-lg-5 ms-auto p-0">
                    <div className="login-box mt-sm-0">
                        <div>
                            <h2><span>Reset password</span></h2>
                            <p>When you provide your email address, we'll send you a message with information on how to
                                reset.</p>

                            {
                                !show ? (
                                    <form className="auth-form" onSubmit={hadleSubmit} >
                                        <div className="mb-3 form-group">
                                            <i className="iconsax" data-icon="mail"></i>
                                            <label htmlFor="emailid" className="form-label">Email ID</label>
                                            <input value={email} onChange={e=>setEmail(e.target.value)} type="email" placeholder="Enter your mail id" className="form-control" id="emailid"/>
                                        </div>
                                        <button data-cursor="pointer" 
                                            className="btn-solid btn-absolute text-center mt-3">Reset
                                            Password</button>
                                    </form>
                                ) :(
                                    <div>
                                        <h3>Forgot Password link send successfully, Check your Email</h3>
                                        <a href="/login">Back to Login ?</a>
                                    </div>
                                )
                            }
                        </div>
                    </div>
                </div>
            </div>
        </section>
        {/* <!-- section end --> */}
    </div>
  )
}
